<template>
    <div>
        <b-list-group v-if="attachmentModels.length>0">
            <b-list-group-item v-for="(item,index) of attachmentModels"
                               :key="index" button>

                <a :href="generatePdfSrc(item)">{{ item.fileName }}</a>

            </b-list-group-item>
        </b-list-group>
        <empty-list-info v-else></empty-list-info>

        <ReBModal header="PDF预览"
                  ref="pdfViewer">
            <div v-if="selectedRow!=null" class="d-flex flex-column">
                <b-button variant="light" @click="toFullscreen">全 屏</b-button>
                <PreviewPdfV2 ref="pdfPreview" :src="generatePdfSrc(selectedRow)"></PreviewPdfV2>
            </div>
        </ReBModal>
    </div>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import PreviewPdfV2 from "@/components/Pdf/PreviewPdfV2";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo";

export default {
    name: "PdfFileList",
    components: {EmptyListInfo, PreviewPdfV2, ReBModal},
    props: {
        attachmentIds: {
            type: String,
            default: ""
        },
        attachments: {
            type: Array
        }
    },
    data() {
        return {
            attachmentModels: [],
            loading: false,
            selectedRow: null,
        }
    },
    watch: {
        loading() {
            this.$emit('loading', this.loading);
        }
    },
    mounted() {
        this.checkIfNeedQuery();
    },
    methods: {
        checkIfNeedQuery() {
            if (this.attachments !== undefined) {
                this.filterFile(this.attachments);
            } else {
                this.getPdfList();
            }
        },
        getPdfList() {
            this.loading = true;
            let url = process.env.VUE_APP_EM_ADMIN_URL +
                "/emAttachment/getAttachmentList?attachmentIds=" + this.attachmentIds;
            this.$store.dispatch('api/get', {url: url}).then(response => {
                if (response.length > 0) {
                    this.filterFile(response);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        filterFile(list) {
            //2024.2.5 按LYQ要求PAD“图纸查看”增加压缩格式附件显示
            const validExtensions = ['.pdf', '.zip', '.rar', '.7z'];
            this.attachmentModels = list.filter(item =>
                validExtensions.some(ext => item.fileName.endsWith(ext))
            );
        },
        generatePdfSrc(row) {
            return process.env.VUE_APP_EM_ADMIN_URL + "/emAttachment/download?attachmentId=" + row.attachmentId;
        },
        routeTo(row) {
            this.selectedRow = row;
            this.$refs.pdfViewer.showModal();
        },
        toFullscreen() {
            if (this.$refs.pdfPreview !== undefined) {
                this.$refs.pdfPreview.handleDbClick();
            }
        }
    }
}
</script>

<style scoped>

</style>